import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { selectObjectLanguageById } from '../../../../../redux/modules/data/objectLanguagesSlice';
import { getLinkOfObject, recentlyViewedObject } from '../../../../../redux/modules/data/objectsSlice';
import { PlayIcon, RestrictedIcon } from '../../../../misc/icons/Icons';
import MediaEmbedModal from '../../../general/MediaEmbedModal';
import FavListsPopover from '../../favorites/partials/FavoritesPopover';

// TODO: pointer-events-none when popover is open? title1, title2, subtitle, date, language, type, thumb, link, video = false, restricted = false
const ObjectTile = ({ object, isSliderTile = false }) => {
	const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);

	const dispatch = useDispatch();

	const objectLanguage = useSelector((state) => selectObjectLanguageById(state, object.objectlaguage_id));

	const url = getLinkOfObject(object);

	let thumbUrl = null;
	if (object.type === 'doc' || object.type === 'link') {
		thumbUrl = `${process.env.REACT_APP_API_BASE_URL}/${object.thumb}`;
	} else if (object.type === 'MAM') {
		thumbUrl = `${process.env.REACT_APP_MAM_THUMB_BASE_URL}${object.thumb}`;
	}

	const handleClick = (e) => {
		dispatch(recentlyViewedObject({ objectId: object.id }));

		if (['pdf', 'video', 'image'].includes(object.file_type)) {
			setIsMediaModalOpen(true);
			e.preventDefault();
		} else if (!url) {
			e.preventDefault();
			console.error('Unexpected behaviour. Not a standard filetype and no url given');
		}
	};

	return (
		<div className={`group flex max-w-tile-mobile sm:max-w-tile relative ${!isSliderTile ? 'w-1/2 xl:w-1/3 2xl:w-1/4 mb-7 sm:mb-20' : 'w-full mb-0'}`}>
			{!url && (<div className="absolute shadow-md top-3 left-1/2 w-28 text-center bg-oly-yellow-default text-oly-gray-footerbar rounded-sm text-sm z-10 -ml-14">iPad only</div>)}
			<a
				href={url ?? '#'}
				target="_blank"
				className={`${!url ? 'opacity-30 bg-oly-gray-lightestAlpha45' : ''} flex flex-col flex-grow p-3 mx-1.5 overflow-hidden text-left bg-white sm:mx-2.5 transform can-hover:group-hover:shadow-lg can-hover:hover:scale-101 focus-visible:shadow-lg focus-visible:scale-101 focus:outline-none rounded-[12px] border-[12px] border-[#FFFFFF]`}
				style={{ boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)' }}
				aria-labelledby={`open-object-${object.title1 + object.title2}`}
				rel="noreferrer"
				onClick={(e) => handleClick(e)}
			>
				<div className="relative flex flex-shrink-0 mb-2 h-24 max-h-24 sm:h-[10.5625rem] sm:max-h-[10.5625rem]">
					<LazyLoadImage
						alt=""
						src={thumbUrl}
						placeholderSrc={`${process.env.PUBLIC_URL}/images/placeholder.png`}
						className="object-contain w-full h-full"
						wrapperClassName="w-full !bg-no-repeat !bg-contain !bg-center"
					/>
					{object.video && <PlayIcon className="absolute inset-0 w-8 h-8 m-auto text-white sm:w-12 sm:h-12" />}
				</div>
				<div className="flex flex-col justify-between flex-grow h-20 sm:h-24 text-oly-gray-darkest">
					<div className="flex flex-col h-8 sm:h-10">
						<span className="text-[0.84375rem] font-semibold leading-4 sm:text-[1.125rem] sm:leading-5 line-clamp-2">
							{object.title1}
							{' '}
							{object.title2}
						</span>
					</div>
					<span className={`text-[0.75rem] line-clamp-1 sm:text-[0.9375rem] ${object.restricted === '1' ? 'mr-5 sm:mr-0' : ''}`}>
						{object.subtitle}
					</span>
					<span className={`text-[0.75rem] line-clamp-1 sm:text-[0.9375rem] uppercase text-oly-gray-dark mr-5 ${object.restricted === '1' ? 'sm:mr-10' : 'sm:mr-0'}`}>
						{object?.updated_at ? `${object?.updated_at}` : ''}
						{objectLanguage?.title ? ` • ${objectLanguage?.title}` : ''}
						{object?.file_type ? ` • ${object?.file_type}` : ''}
						{object?.type === 'link' ? ` • ${object?.type}` : ''}
					</span>
				</div>
			</a>
			<div className="absolute bottom-0 flex flex-col items-center sm:flex-row right-1 sm:bottom-2 sm:right-4">
				{object.restricted === '1' && <RestrictedIcon className="w-4 h-4 sm:w-6 sm:h-6 text-oly-gray-darkest sm:mr-1" />}
				<FavListsPopover isSliderTile={isSliderTile} object={object} />
			</div>

			{
				isMediaModalOpen
					? (
						<MediaEmbedModal
							isModalOpen={isMediaModalOpen}
							setIsModalOpen={setIsMediaModalOpen}
							fileUrl={url}
							fileType={object.file_type}
						/>
					)
					: null
			}
		</div>
	);
};

export default ObjectTile;
